import { useMemo } from 'react';
import { useAuth, hasSuperAdminAccess } from '../../contexts/AuthContext';

export type AdminSection =
  | 'user-management'
  | 'corporate-user-management'
  | 'listing-management'
  | 'reel-management'
  | 'data-management'
  | 'support-tickets'
  | 'moderation'
  | 'utm-kaynaklari'
  | 'analytics';

export type AdminMenuItem = {
  key: AdminSection | 'admin-logs' | 'security-logs';
  path: string;
  label: string;
  icon: string;
};

export const baseAdminMenuItems: AdminMenuItem[] = [
  { key: 'user-management', path: '/admin-panel/user-management', label: 'Kullanıcı Yönetimi', icon: 'fa-users' },
  {
    key: 'corporate-user-management',
    path: '/admin-panel/corporate-user-management',
    label: 'Kurumsal Kullanıcı Yönetimi',
    icon: 'fa-building',
  },
  { key: 'listing-management', path: '/admin-panel/listing-management', label: 'İlan Yönetimi', icon: 'fa-list' },
  { key: 'reel-management', path: '/admin-panel/reel-management', label: 'Gönderi Yönetimi', icon: 'fa-video' },
  { key: 'data-management', path: '/admin-panel/data-management', label: 'Veri Yönetimi', icon: 'fa-database' },
  { key: 'support-tickets', path: '/admin-panel/support-tickets', label: 'Destek Talepleri', icon: 'fa-headset' },
  { key: 'moderation', path: '/admin-panel/moderation', label: 'Moderasyon', icon: 'fa-shield-alt' },
  { key: 'utm-kaynaklari', path: '/admin-panel/utm-kaynaklari', label: 'UTM Kaynakları', icon: 'fa-chart-line' },
  { key: 'analytics', path: '/admin-panel/analytics', label: 'Analitik', icon: 'fa-chart-pie' },
];

export const superAdminMenuItems: AdminMenuItem[] = [
  {
    key: 'admin-logs',
    path: '/admin-panel/admin-logs',
    label: 'Yönetici Logları',
    icon: 'fa-clipboard-list',
  },
  {
    key: 'security-logs',
    path: '/admin-panel/security-logs',
    label: 'Güvenlik Logları',
    icon: 'fa-shield-virus',
  },
];

export function useAdminMenuItems(): AdminMenuItem[] {
  const { user } = useAuth();

  return useMemo(() => {
    if (hasSuperAdminAccess(user)) {
      return [...baseAdminMenuItems, ...superAdminMenuItems];
    }
    return baseAdminMenuItems;
  }, [user]);
}
